import cx from 'classnames';
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import React, { useMemo } from 'react';
import styles from './bubble.module.css';

marked.setOptions({ breaks: true, gfm: true });

export const AIChatBubble = ({ message, type, is_user }) => {
  const html = useMemo(() => {
    const raw = marked.parse(message || '');
    return DOMPurify.sanitize(raw);
  }, [message]);

  if (type === 'thinking') {
    return (
      <div>
        <div className={styles.thinkingBubble}>
          <span className={styles.dot} />
          <span className={styles.dot} />
          <span className={styles.dot} />
        </div>
      </div>
    );
  }

  return (
    <div className={cx(styles.bubble, { [styles.user]: is_user })}>
      <div className={styles.messageContent} dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
};
